module.exports = __webpack_public_path__ + "img/C1_HQ01.0afe8a58.jpg";